<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-10 md:col-offset-1">
      <p-panel header="{{ 'ESTRUCTURAFISICA.LBL_ESTRUCTURA' | translate}}" *ngIf="estFisica">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estFisica.estructuraFisica}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_CATEGORIA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.categoria}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_NUMEROZONAS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estFisica.numeroZonas}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_VIRTUAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estFisica.indicadorVirtual ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>

          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{estFisica.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-10 md:col-offset-1">
      <p-panel header="{{ 'ESTRUCTURAFISICA.LBL_ZONA' | translate}}">
        <p-table [columns]="columnas"
                 [value]="zonas" selectionMode="single" dataKey="idZona"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigo}}</td>
              <td>{{row.nombre}}</td>
              <td>{{row.clasificacionZona}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
